// extracted by mini-css-extract-plugin
module.exports = {"title":"academic-module--title--38MVG","wrapper":"academic-module--wrapper--3H0V_","item":"academic-module--item--SjeAM","skillsWrapper":"academic-module--skills-wrapper--33RFo"};